import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "interiors-page" }
const _hoisted_2 = { class: "page-shell" }
const _hoisted_3 = { class: "mobile-page-title" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "content-grid" }
const _hoisted_6 = { class: "main-column" }
const _hoisted_7 = { class: "hero-section" }
const _hoisted_8 = {
  class: "hero-image-wr",
  ref: "heroImageWr"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "hero-description" }
const _hoisted_11 = { class: "section-floorplan" }
const _hoisted_12 = { class: "floorplan-card" }
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "floorplan-enlarge" }
const _hoisted_16 = { class: "floorplan-stats" }
const _hoisted_17 = { class: "stat-item" }
const _hoisted_18 = { class: "stat-text" }
const _hoisted_19 = { class: "stat-item" }
const _hoisted_20 = { class: "stat-text" }
const _hoisted_21 = { class: "stat-item" }
const _hoisted_22 = { class: "stat-text" }
const _hoisted_23 = { class: "stat-item" }
const _hoisted_24 = {
  key: 0,
  class: "stat-item"
}
const _hoisted_25 = { class: "stat-text" }
const _hoisted_26 = {
  key: 0,
  class: "section-features"
}
const _hoisted_27 = { class: "features-card" }
const _hoisted_28 = { class: "features-list" }
const _hoisted_29 = {
  key: 1,
  class: "section-inclusions"
}
const _hoisted_30 = { class: "inclusions-accordion" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "accordion-header__title" }
const _hoisted_33 = { class: "accordion-body__inner" }
const _hoisted_34 = { class: "inclusion-list" }
const _hoisted_35 = { class: "inclusion-item__text" }
const _hoisted_36 = {
  key: 2,
  class: "section-facades"
}
const _hoisted_37 = { class: "facade-grid" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "facade-image-wr" }
const _hoisted_40 = ["src", "alt"]
const _hoisted_41 = {
  key: 0,
  class: "facade-overlay"
}
const _hoisted_42 = {
  key: 1,
  class: "facade-selected-badge"
}
const _hoisted_43 = { class: "facade-body" }
const _hoisted_44 = { class: "facade-title" }
const _hoisted_45 = {
  key: 0,
  class: "facade-desc"
}
const _hoisted_46 = {
  key: 3,
  class: "section-schemes"
}
const _hoisted_47 = { class: "scheme-cards-grid" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "scheme-select-card__body" }
const _hoisted_50 = { class: "scheme-select-card__name" }
const _hoisted_51 = {
  key: 0,
  class: "scheme-select-card__desc"
}
const _hoisted_52 = {
  key: 0,
  class: "scheme-select-card__check"
}
const _hoisted_53 = {
  key: 0,
  class: "scheme-detail-card"
}
const _hoisted_54 = {
  key: 0,
  class: "scheme-room-gallery"
}
const _hoisted_55 = { class: "scheme-room-main" }
const _hoisted_56 = ["src", "alt"]
const _hoisted_57 = { class: "scheme-room-main__label" }
const _hoisted_58 = {
  key: 0,
  class: "scheme-thumbnails"
}
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["src", "alt"]
const _hoisted_61 = { class: "scheme-thumb__label" }
const _hoisted_62 = {
  key: 1,
  class: "scheme-materials"
}
const _hoisted_63 = { class: "scheme-materials__grid" }
const _hoisted_64 = { class: "scheme-material-info" }
const _hoisted_65 = { class: "scheme-material-label" }
const _hoisted_66 = {
  key: 0,
  class: "scheme-material-name"
}
const _hoisted_67 = {
  key: 1,
  class: "scheme-material-value"
}
const _hoisted_68 = { class: "scheme-mobile-list" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 0,
  class: "scheme-mobile-preview"
}
const _hoisted_71 = ["src", "alt"]
const _hoisted_72 = { class: "scheme-mobile-preview__label" }
const _hoisted_73 = {
  key: 0,
  class: "scheme-mobile-check"
}
const _hoisted_74 = { class: "scheme-mobile-body" }
const _hoisted_75 = { class: "scheme-mobile-title" }
const _hoisted_76 = {
  key: 0,
  class: "scheme-mobile-desc"
}
const _hoisted_77 = {
  key: 1,
  class: "scheme-mobile-thumbnails"
}
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["src", "alt"]
const _hoisted_80 = {
  key: 4,
  class: "section-upgrades"
}
const _hoisted_81 = { class: "upgrades-list" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 0,
  class: "upgrade-mobile-image-wr"
}
const _hoisted_84 = ["src", "alt"]
const _hoisted_85 = {
  key: 0,
  class: "upgrade-mobile-badge"
}
const _hoisted_86 = {
  key: 1,
  class: "upgrade-mobile-badge upgrade-mobile-badge--hint"
}
const _hoisted_87 = { class: "upgrade-radio" }
const _hoisted_88 = {
  key: 0,
  class: "upgrade-radio-filled"
}
const _hoisted_89 = { class: "upgrade-info" }
const _hoisted_90 = { class: "upgrade-price-inline" }
const _hoisted_91 = {
  key: 0,
  class: "upgrade-desc"
}
const _hoisted_92 = {
  key: 1,
  class: "upgrade-image-wr"
}
const _hoisted_93 = ["src", "alt"]
const _hoisted_94 = { class: "side-column" }
const _hoisted_95 = { class: "summary-card" }
const _hoisted_96 = {
  class: "card-view",
  key: "summary"
}
const _hoisted_97 = { class: "summary-text" }
const _hoisted_98 = { class: "lot-link" }
const _hoisted_99 = {
  key: 0,
  class: "summary-selections"
}
const _hoisted_100 = ["disabled"]
const _hoisted_101 = {
  key: 0,
  class: "summary-selection-item"
}
const _hoisted_102 = { class: "selection-value" }
const _hoisted_103 = { class: "selection-value" }
const _hoisted_104 = {
  key: 0,
  class: "compatible-lots-notice"
}
const _hoisted_105 = {
  key: 1,
  class: "compatible-lots-notice no-lots"
}
const _hoisted_106 = {
  key: 2,
  class: "cta-hint"
}
const _hoisted_107 = ["disabled"]
const _hoisted_108 = { class: "summary-price-block" }
const _hoisted_109 = { class: "price-value" }
const _hoisted_110 = {
  key: 4,
  class: "cta-btn cta-reserve-disabled",
  disabled: ""
}
const _hoisted_111 = {
  class: "card-view card-view--form",
  key: "info-pack"
}
const _hoisted_112 = { class: "form-field" }
const _hoisted_113 = {
  key: 0,
  class: "form-error"
}
const _hoisted_114 = { class: "form-field" }
const _hoisted_115 = {
  key: 0,
  class: "form-error"
}
const _hoisted_116 = { class: "form-field" }
const _hoisted_117 = {
  key: 0,
  class: "form-error"
}
const _hoisted_118 = { class: "form-field" }
const _hoisted_119 = ["disabled"]
const _hoisted_120 = {
  key: 1,
  class: "info-pack-success"
}
const _hoisted_121 = {
  key: 1,
  class: "mobile-bottom-nav-trigger",
  ref: "mobileBottomNavTrigger",
  "aria-hidden": "true"
}
const _hoisted_122 = { class: "mobile-summary-copy" }
const _hoisted_123 = { class: "mobile-summary-title" }
const _hoisted_124 = {
  key: 0,
  class: "mobile-summary-status"
}
const _hoisted_125 = {
  key: 1,
  class: "mobile-summary-status"
}
const _hoisted_126 = { class: "mobile-summary-price" }
const _hoisted_127 = {
  key: 0,
  class: "mobile-summary-actions"
}
const _hoisted_128 = ["disabled"]
const _hoisted_129 = ["disabled"]
const _hoisted_130 = {
  key: 2,
  class: "mobile-summary-btn mobile-summary-btn--disabled",
  disabled: ""
}
const _hoisted_131 = { class: "facade-conflict-modal" }
const _hoisted_132 = { class: "facade-conflict-body" }
const _hoisted_133 = { class: "floorplan-modal" }
const _hoisted_134 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.isEmbedded)
      ? (_openBlock(), _createBlock($setup["CustomerNavbar"], {
          key: 0,
          logoUrl: $setup.projectPageData?.residentialContent?.logoImageUrl,
          brandText: $setup.projectPageData?.residentialContent?.brandText || $setup.estateName,
          showMap: !!$setup.estateId,
          onBack: $setup.goBack,
          onMapClick: $setup.openMasterplan
        }, null, 8, ["logoUrl", "brandText", "showMap"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["mobile-title-bar", { 'mobile-title-bar--embedded': $setup.isEmbedded }])
      }, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString($setup.house?.name || ""), 1)
      ], 2),
      _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.house?.name || ""), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("section", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                class: "hero-image",
                src: $setup.heroImage,
                alt: $setup.house?.name || 'House design'
              }, null, 8, _hoisted_9)
            ], 512),
            _createElementVNode("p", _hoisted_10, _toDisplayString($setup.house?.description || $setup.defaultDescription), 1)
          ]),
          _createElementVNode("section", _hoisted_11, [
            _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "section-title" }, "Floorplan", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "floorplan-image-wr",
                type: "button",
                "aria-label": `Open full-size floorplan for ${$setup.house?.name || 'this home design'}`,
                onClick: $setup.openFloorplanPreview
              }, [
                _createElementVNode("img", {
                  class: "floorplan-image",
                  src: $setup.floorplanImage,
                  alt: $setup.house?.name || 'Floorplan'
                }, null, 8, _hoisted_14),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode($setup["Maximize2"], { size: 18 }),
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "View Full Size", -1))
                ])
              ], 8, _hoisted_13),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode($setup["Bed"], {
                    class: "stat-icon",
                    size: 22
                  }),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", null, _toDisplayString($setup.house?.bedroom || 0) + " Bed", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode($setup["Bath"], {
                    class: "stat-icon",
                    size: 22
                  }),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString($setup.house?.bathroom?.quantity || 0) + " Bath", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode($setup["Car"], {
                    class: "stat-icon",
                    size: 22
                  }),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", null, _toDisplayString($setup.house?.garage || 0) + " Car", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode($setup["Sofa"], {
                    class: "stat-icon",
                    size: 22
                  }),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-text" }, [
                    _createElementVNode("span", null, "Living")
                  ], -1))
                ]),
                ($setup.house?.area)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode($setup["Maximize2"], {
                        class: "stat-icon",
                        size: 22
                      }),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", null, _toDisplayString($setup.formatArea($setup.house?.area)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          ($setup.featureList.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
                _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "section-title" }, "Home Features", -1)),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("ul", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.featureList, (feature) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "feature-item",
                        key: feature
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "feature-dot" }, "•", -1)),
                        _createElementVNode("span", null, _toDisplayString(feature), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.inclusionSections.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "section-title" }, "Home Inclusions", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "section-subtitle" }, "Every detail has been carefully considered to create a home that feels complete from day one.", -1)),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.inclusionSections, (section) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "accordion-item",
                      key: section.key
                    }, [
                      _createElementVNode("button", {
                        class: "accordion-header",
                        onClick: ($event: any) => ($setup.toggleInclusion(section.key))
                      }, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(section.title), 1),
                        _createVNode($setup["ChevronDown"], {
                          class: _normalizeClass(["accordion-chevron", { open: $setup.isInclusionOpen(section.key) }]),
                          size: 18
                        }, null, 8, ["class"])
                      ], 8, _hoisted_31),
                      _createElementVNode("div", {
                        class: _normalizeClass(["accordion-body", { open: $setup.isInclusionOpen(section.key) }])
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("ul", _hoisted_34, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "inclusion-item",
                                key: item
                              }, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "inclusion-check" }, "✓", -1)),
                                _createElementVNode("span", _hoisted_35, _toDisplayString(item), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ], 2)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.house?.facades?.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
                _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "section-title" }, "Browse Facades", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "section-subtitle" }, "Choose from our range of thoughtfully designed facade options. Tap a facade below to select it for your home.", -1)),
                _createElementVNode("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.house.facades, (facade) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(["facade-card", { selected: $setup.selectedFacadeId === String(facade._id) }]),
                      key: facade._id,
                      onClick: ($event: any) => ($setup.selectFacade(String(facade._id)))
                    }, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("img", {
                          class: "facade-image",
                          src: facade.url,
                          alt: facade.name
                        }, null, 8, _hoisted_40),
                        ($setup.selectedFacadeId !== String(facade._id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Tap to select"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_42, "Selected"))
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("h3", _hoisted_44, _toDisplayString(facade.name), 1),
                        (facade.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(facade.description), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_38))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.allColorSchemes.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
                _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "section-title" }, "Interior Colour Schemes", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "section-subtitle" }, "Choose your preferred interior colour scheme to personalise your home.", -1)),
                _createElementVNode("div", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allColorSchemes, (scheme) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["scheme-select-card", { active: $setup.selectedInternalSchemeId === scheme._id }]),
                      key: scheme._id,
                      onClick: ($event: any) => ($setup.selectInternalScheme(scheme._id))
                    }, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_50, _toDisplayString(scheme.name), 1),
                          (scheme.description)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(scheme.description), 1))
                            : _createCommentVNode("", true)
                        ]),
                        ($setup.selectedInternalSchemeId === scheme._id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createVNode($setup["Check"], { size: 16 })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_48))
                  }), 128))
                ]),
                ($setup.selectedInternalScheme)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      ($setup.displayRoomImages.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("img", {
                                class: "scheme-room-main__img",
                                src: $setup.displayRoomImages[$setup.activeRoomIndex].url,
                                alt: $setup.displayRoomImages[$setup.activeRoomIndex].name
                              }, null, 8, _hoisted_56),
                              _createElementVNode("div", _hoisted_57, _toDisplayString($setup.selectedInternalScheme.name) + " — " + _toDisplayString($setup.displayRoomImages[$setup.activeRoomIndex].name), 1)
                            ]),
                            ($setup.displayRoomImages.length > 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayRoomImages, (img, i) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      class: _normalizeClass(["scheme-thumb", { active: i === $setup.activeRoomIndex }]),
                                      key: i,
                                      type: "button",
                                      onClick: ($event: any) => ($setup.activeRoomIndex = i)
                                    }, [
                                      _createElementVNode("img", {
                                        src: img.url,
                                        alt: img.name
                                      }, null, 8, _hoisted_60),
                                      _createElementVNode("span", _hoisted_61, _toDisplayString(img.name), 1)
                                    ], 10, _hoisted_59))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.materialsByCategory.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "scheme-materials__title" }, "Materials & Finishes", -1)),
                            _createElementVNode("div", _hoisted_63, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.materialsByCategory, (material) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "scheme-material-item",
                                  key: material.key
                                }, [
                                  _createElementVNode("div", {
                                    class: "scheme-material-swatch",
                                    style: _normalizeStyle(material.swatchStyle)
                                  }, null, 4),
                                  _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("span", _hoisted_65, _toDisplayString(material.name), 1),
                                    (material.label)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(material.label), 1))
                                      : _createCommentVNode("", true),
                                    (material.details)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(material.details), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_68, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mobileSchemeCards, (card) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["scheme-mobile-card", { active: $setup.selectedInternalSchemeId === card.scheme._id }]),
                      key: card.scheme._id,
                      onClick: ($event: any) => ($setup.selectInternalScheme(card.scheme._id))
                    }, [
                      (card.activeRoom)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _createElementVNode("img", {
                              class: "scheme-mobile-preview__img",
                              src: card.activeRoom.url,
                              alt: card.activeRoom.name
                            }, null, 8, _hoisted_71),
                            _createElementVNode("div", _hoisted_72, _toDisplayString(card.activeRoom.name), 1),
                            ($setup.selectedInternalSchemeId === card.scheme._id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                  _createVNode($setup["Check"], { size: 14 })
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("h3", _hoisted_75, _toDisplayString(card.scheme.name), 1),
                        (card.scheme.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_76, _toDisplayString(card.scheme.description), 1))
                          : _createCommentVNode("", true),
                        (card.roomImages.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.roomImages, (img, i) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  class: _normalizeClass(["scheme-mobile-thumb", { active: i === card.activeIndex }]),
                                  key: i,
                                  type: "button",
                                  onClick: _withModifiers(($event: any) => ($setup.selectMobileSchemeRoom(card.scheme._id, i)), ["stop"])
                                }, [
                                  _createElementVNode("img", {
                                    src: img.url,
                                    alt: img.name
                                  }, null, 8, _hoisted_79)
                                ], 10, _hoisted_78))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_69))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.allOptionalUpgrades.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_80, [
                _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "section-title" }, "Optional Upgrades", -1)),
                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "section-subtitle" }, "Enhance your home with these premium upgrades", -1)),
                _createElementVNode("div", _hoisted_81, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allOptionalUpgrades, (upgrade) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["upgrade-item", { selected: $setup.selectedUpgradeIds.includes(upgrade._id) }]),
                      key: upgrade._id,
                      onClick: ($event: any) => ($setup.toggleUpgrade(upgrade._id))
                    }, [
                      (upgrade.url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("img", {
                              class: "upgrade-mobile-image",
                              src: upgrade.url,
                              alt: upgrade.name
                            }, null, 8, _hoisted_84),
                            ($setup.selectedUpgradeIds.includes(upgrade._id))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [...(_cache[21] || (_cache[21] = [
                                  _createElementVNode("span", null, "Added", -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_86, [...(_cache[22] || (_cache[22] = [
                                  _createElementVNode("span", null, "Tap to add", -1)
                                ]))]))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_87, [
                        ($setup.selectedUpgradeIds.includes(upgrade._id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("span", { class: "upgrade-check-icon" }, "✓", -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["upgrade-title", { active: $setup.selectedUpgradeIds.includes(upgrade._id) }])
                        }, _toDisplayString(upgrade.name), 3),
                        _createElementVNode("span", _hoisted_90, "+" + _toDisplayString($setup.formatPrice(upgrade.price || 0)), 1),
                        ($setup.formatUpgradeDescription(upgrade))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString($setup.formatUpgradeDescription(upgrade)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (upgrade.url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                            _createElementVNode("img", {
                              class: "upgrade-image",
                              src: upgrade.url,
                              alt: upgrade.name
                            }, null, 8, _hoisted_93)
                          ]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_82))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("aside", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createVNode(_Transition, {
              name: "card-flip",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                ($setup.sidebarView === 'summary')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                      _cache[42] || (_cache[42] = _createElementVNode("h3", { class: "summary-title" }, "Your Home", -1)),
                      _createElementVNode("p", _hoisted_97, [
                        _cache[30] || (_cache[30] = _createTextVNode("You've selected the ", -1)),
                        _createElementVNode("strong", null, _toDisplayString($setup.house?.name || ""), 1),
                        _cache[31] || (_cache[31] = _createTextVNode(" design", -1)),
                        ($setup.selectedFacade)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[26] || (_cache[26] = _createTextVNode(" with ", -1)),
                              _createElementVNode("strong", null, _toDisplayString($setup.selectedFacade.name), 1),
                              _cache[27] || (_cache[27] = _createTextVNode(" facade", -1))
                            ], 64))
                          : _createCommentVNode("", true),
                        _cache[32] || (_cache[32] = _createTextVNode(".", -1)),
                        ($setup.selectedLot)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[28] || (_cache[28] = _createTextVNode(" You've chosen ", -1)),
                              _createElementVNode("strong", _hoisted_98, "Lot " + _toDisplayString($setup.selectedLot.title), 1),
                              _cache[29] || (_cache[29] = _createTextVNode(".", -1))
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      ($setup.selectedInternalScheme || $setup.selectedUpgradeIds.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_99))
                        : _createCommentVNode("", true),
                      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
                      ($setup.selectedLotId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              class: "change-lot-btn",
                              onClick: $setup.openMasterplan,
                              disabled: !$setup.estateId
                            }, [
                              _createVNode($setup["Map"], {
                                class: "change-lot-icon",
                                size: 15
                              }),
                              _cache[33] || (_cache[33] = _createElementVNode("span", null, "Change Lot", -1))
                            ], 8, _hoisted_100),
                            ($setup.selectedInternalScheme)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                  _cache[34] || (_cache[34] = _createElementVNode("span", { class: "selection-label" }, "Colour Scheme", -1)),
                                  _createElementVNode("span", _hoisted_102, _toDisplayString($setup.selectedInternalScheme.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.selectedUpgradeIds.length)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.selectedUpgradeIds, (upgradeId) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "summary-selection-item",
                                    key: upgradeId
                                  }, [
                                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "selection-label" }, "Upgrade", -1)),
                                    _createElementVNode("span", _hoisted_103, _toDisplayString($setup.allOptionalUpgrades.find((u) => u._id === upgradeId)?.name), 1)
                                  ]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            ($setup.compatibleLots.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                  _cache[36] || (_cache[36] = _createTextVNode("Only ", -1)),
                                  _createElementVNode("span", {
                                    class: "lots-highlight",
                                    onClick: $setup.openMasterplan
                                  }, _toDisplayString($setup.compatibleLots.length) + " compatible " + _toDisplayString($setup.compatibleLots.length === 1 ? "lot" : "lots"), 1),
                                  _createTextVNode(" remaining for this design" + _toDisplayString($setup.selectedFacade ? " & facade combination" : ""), 1)
                                ]))
                              : ($setup.lots.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                    (!$setup.hasAnyAvailableLots)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode("Unfortunately, your selected design is not currently available. Talk with our sales team about upcoming releases.")
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode("Unfortunately, your selected design & facade combo is not currently available. You can select a different facade or talk with our sales team about upcoming releases.")
                                        ], 64))
                                  ]))
                                : _createCommentVNode("", true),
                            ($setup.compatibleLots.length > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_106, "Select your preferred lot to continue"))
                              : _createCommentVNode("", true),
                            ($setup.compatibleLots.length > 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  class: "cta-btn cta-map-btn",
                                  onClick: $setup.openMasterplan,
                                  disabled: !$setup.estateId || !$setup.compatibleLots.length
                                }, [
                                  _createVNode($setup["Map"], {
                                    class: "map-btn-icon",
                                    size: 16
                                  }),
                                  _cache[37] || (_cache[37] = _createElementVNode("span", null, "View Lots on Map", -1))
                                ], 8, _hoisted_107))
                              : _createCommentVNode("", true)
                          ], 64)),
                      _cache[44] || (_cache[44] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
                      _createElementVNode("div", _hoisted_108, [
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "price-label" }, "Total Price", -1)),
                        _createElementVNode("span", _hoisted_109, _toDisplayString($setup.displayPrice), 1),
                        _cache[39] || (_cache[39] = _createElementVNode("p", { class: "price-note" }, "Includes base home price, inclusions & selected upgrades", -1))
                      ]),
                      ($setup.selectedLotId)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            class: "cta-btn",
                            onClick: $setup.navigateToEOI
                          }, [
                            _createVNode($setup["Lock"], { size: 14 }),
                            _createElementVNode("span", null, "Request Hold on Lot " + _toDisplayString($setup.selectedLot.title), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("button", _hoisted_110, [
                            _createVNode($setup["Lock"], { size: 14 }),
                            _cache[40] || (_cache[40] = _createElementVNode("span", null, "Request Hold", -1))
                          ])),
                      _createElementVNode("button", {
                        class: "cta-btn cta-secondary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.sidebarView = 'info-pack'))
                      }, [
                        _createVNode($setup["FileText"], { size: 14 }),
                        _cache[41] || (_cache[41] = _createElementVNode("span", null, "Request Info Pack", -1))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_111, [
                      _createElementVNode("button", {
                        class: "info-pack-back",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.sidebarView = 'summary'))
                      }, [
                        _createVNode($setup["ArrowLeft"], { size: 16 }),
                        _cache[45] || (_cache[45] = _createElementVNode("span", null, "Back", -1))
                      ]),
                      (!$setup.infoPackSubmitted)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[50] || (_cache[50] = _createElementVNode("h3", { class: "info-pack-title" }, "Request an Info Pack", -1)),
                            _cache[51] || (_cache[51] = _createElementVNode("p", { class: "info-pack-subtitle" }, "Enter your details and we'll send you our full information pack.", -1)),
                            _createElementVNode("div", _hoisted_112, [
                              _cache[46] || (_cache[46] = _createElementVNode("label", { class: "form-label" }, "Full Name *", -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: "form-input",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.infoPackForm.fullName) = $event)),
                                type: "text",
                                placeholder: "Enter your full name"
                              }, null, 512), [
                                [_vModelText, $setup.infoPackForm.fullName]
                              ]),
                              ($setup.infoPackErrors.fullName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString($setup.infoPackErrors.fullName), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label" }, "Email *", -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: "form-input",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.infoPackForm.email) = $event)),
                                type: "email",
                                placeholder: "you@example.com"
                              }, null, 512), [
                                [_vModelText, $setup.infoPackForm.email]
                              ]),
                              ($setup.infoPackErrors.email)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString($setup.infoPackErrors.email), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                              _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label" }, "Phone *", -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: "form-input",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.infoPackForm.phone) = $event)),
                                type: "tel",
                                placeholder: "04XX XXX XXX"
                              }, null, 512), [
                                [_vModelText, $setup.infoPackForm.phone]
                              ]),
                              ($setup.infoPackErrors.phone)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString($setup.infoPackErrors.phone), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_118, [
                              _cache[49] || (_cache[49] = _createElementVNode("label", { class: "form-label" }, "Message (optional)", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "form-input form-textarea",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.infoPackForm.message) = $event)),
                                placeholder: "Any questions or comments..."
                              }, null, 512), [
                                [_vModelText, $setup.infoPackForm.message]
                              ])
                            ]),
                            _createElementVNode("button", {
                              class: "cta-btn",
                              disabled: $setup.infoPackSubmitting,
                              onClick: $setup.submitInfoPack
                            }, [
                              ($setup.infoPackSubmitting)
                                ? (_openBlock(), _createBlock($setup["Loader2"], {
                                    key: 0,
                                    class: "submit-spinner",
                                    size: 16
                                  }))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", null, _toDisplayString($setup.infoPackSubmitting ? "Sending..." : "Send Info Pack Request"), 1)
                            ], 8, _hoisted_119)
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_120, [
                            _cache[52] || (_cache[52] = _createElementVNode("svg", {
                              class: "success-checkmark",
                              viewBox: "0 0 52 52"
                            }, [
                              _createElementVNode("circle", {
                                class: "success-circle",
                                cx: "26",
                                cy: "26",
                                r: "25",
                                fill: "none"
                              }),
                              _createElementVNode("path", {
                                class: "success-check",
                                fill: "none",
                                d: "M14.1 27.2l7.1 7.2 16.7-16.8"
                              })
                            ], -1)),
                            _cache[53] || (_cache[53] = _createElementVNode("h3", { class: "success-title" }, "Request Received", -1)),
                            _cache[54] || (_cache[54] = _createElementVNode("p", { class: "success-subtitle" }, "Thanks! Our team will be in touch with you shortly.", -1)),
                            _createElementVNode("button", {
                              class: "cta-btn",
                              onClick: $setup.resetInfoPack
                            }, "Done")
                          ]))
                    ]))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    ($setup.estateId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_121, null, 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-summary-bar", { 'mobile-summary-bar--bottom': !$setup.estateId || !$setup.showMobileBottomNavigation }])
    }, [
      _createElementVNode("div", _hoisted_122, [
        _createElementVNode("span", _hoisted_123, _toDisplayString($setup.house?.name || "Your Home"), 1),
        (!$setup.selectedFacade)
          ? (_openBlock(), _createElementBlock("span", _hoisted_124, "Select Facade"))
          : (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString($setup.selectedFacade.name) + " Facade", 1)),
        _createElementVNode("span", _hoisted_126, _toDisplayString($setup.displayPrice), 1)
      ]),
      ($setup.selectedLotId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
            _createElementVNode("button", {
              class: "mobile-summary-btn mobile-summary-btn--secondary",
              onClick: $setup.openMasterplan,
              disabled: !$setup.estateId
            }, "Change Lot", 8, _hoisted_128),
            _createElementVNode("button", {
              class: "mobile-summary-btn",
              onClick: $setup.navigateToEOI
            }, "Request Hold")
          ]))
        : ($setup.compatibleLots.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "mobile-summary-btn mobile-summary-btn--compatible",
              onClick: $setup.openMasterplan,
              disabled: !$setup.estateId || !$setup.compatibleLots.length
            }, "View Compatible Lots", 8, _hoisted_129))
          : (_openBlock(), _createElementBlock("button", _hoisted_130, "No Lots"))
    ], 2),
    ($setup.estateId && $setup.showMobileBottomNavigation)
      ? (_openBlock(), _createBlock($setup["CustomerBottomNavigation"], {
          key: 2,
          currentView: "detail",
          onNavigate: $setup.handleBottomNavigate
        }))
      : _createCommentVNode("", true),
    ($setup.showFacadeConflictModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "facade-conflict-overlay",
          onClick: _withModifiers($setup.keepLot, ["self"])
        }, [
          _createElementVNode("div", _hoisted_131, [
            _cache[55] || (_cache[55] = _createElementVNode("h3", { class: "facade-conflict-title" }, "This facade is not compatible with your selected lot", -1)),
            _createElementVNode("p", _hoisted_132, "Lot " + _toDisplayString($setup.selectedLot?.title) + " is only compatible with the " + _toDisplayString($setup.house?.name) + " home design and " + _toDisplayString($setup.selectedFacade?.name) + " facade. Switching facade will remove your lot selection, you'll need to choose a new compatible lot.", 1),
            _createElementVNode("div", { class: "facade-conflict-actions" }, [
              _createElementVNode("button", {
                class: "facade-conflict-keep",
                onClick: $setup.keepLot
              }, "Keep My Lot"),
              _createElementVNode("button", {
                class: "facade-conflict-change",
                onClick: $setup.confirmFacadeChange
              }, "Change Facade")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.isFloorplanOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "floorplan-modal-overlay",
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.isFloorplanOpen = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("button", {
              class: "floorplan-modal-close",
              type: "button",
              "aria-label": "Close floorplan full view",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.isFloorplanOpen = false))
            }, "×"),
            _createElementVNode("img", {
              class: "floorplan-modal-image",
              src: $setup.floorplanImage,
              alt: `${$setup.house?.name || 'House design'} floorplan enlarged view`
            }, null, 8, _hoisted_134)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}